var htmlEl = document.documentElement,
    bodyEl = document.body,
    htmlClasses = htmlEl.classList,
    bodyClasses = bodyEl.classList;

function switchScrolling(scrollingOn) {
    htmlClasses.toggle('oh', !scrollingOn);
}

function switchLayer(active) {
    bodyClasses.toggle('__layer', active);
}

export default { switchScrolling, switchLayer };

export { switchScrolling, switchLayer };
